import React from "react";
import { useSelector } from "react-redux";

const BeforePreSale = ({ preSaleStarted, indvidualReserve, totalReserve }) => {
  const address = useSelector((state) => state.wallet.walletAddress);

  if (preSaleStarted) {
    return <></>;
  }

  return (
    <div className="sale-price">
      <div className="ps-lg-5">
        <div className=" pb-2">
          {address && indvidualReserve > 0 ? (
            <p
              className="description mt-2 pb-2 text-white"
              style={{ fontSize: "0.97em" }}
            >
              Total <b> {indvidualReserve} </b> GangstaBet
              {indvidualReserve > 1 ? "s" : ""} reserved by {address}
            </p>
          ) : (
            ""
          )}
          {/* {totalReserve > 0 ? (
            <p className="description mt-2 pb-2">
              Total reserved of gangster{totalReserve > 1 ? "s" : ""} is{" "}
              {totalReserve}
            </p>
          ) : (
            ""
          )} */}

          <p className="description mt-2 pb-2">
            Pre-sale of GangstaBet will start soon. To ensure a fair
            distribution, participants will not know their characters when they
            buy. The characters will be randomly picked by an on-chain algorithm
            and cannot to known before the purchase.
          </p>

          <p className="description mt-30 pb-2">
            <strong>
              If you buy the NFT during the pre-sale, you will receive extra
              $GBET tokens that can be used to increase the skills of your
              GangstaBets.
            </strong>
          </p>
        </div>
      </div>
    </div>
  );
};

export default BeforePreSale;
